module.exports = __webpack_public_path__ + "img/step3-desktop.1131242a.jpg";